import { registerPlugin } from '@capacitor/core';
const ExportBase64ImageToGallery = registerPlugin('ExportBase64ImageToGallery', {
    web: () => import('./web').then(m => new m.ExportBase64ImageToGalleryWeb()),
});
export * from './definitions';
export { ExportBase64ImageToGallery };
//# sourceMappingURL=index.js.map